import { render, staticRenderFns } from "./ContentBlockURL.vue?vue&type=template&id=62811c3a&"
import script from "./ContentBlockURL.vue?vue&type=script&lang=js&"
export * from "./ContentBlockURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports